@defer (when isOpened) {
  <sd-modal-default
    [noPadding]="true"
    [brand]="brand"
    modalCustomClass="c__modal-add-to-cart"
    [modalTitleLevel]="4"
    [modalTitle]="'cart.modal.add.title' | translate"
    [(isOpened)]="isOpened"
    (isOpenedChange)="modalClosed($event)"
  >
    <div class="c__add-to-cart-modal-body" sd-modal-body>
      @if (product && !quantityExceededError && !globalError && !addedWithInvalidProductType) {
        <sd-product-customer
          [indexFollow]="product?.indexFollow"
          [isReadOnly]="true"
          [hasNoActions]="true"
          [isBundle]="isBundle"
          [productInfo]="product"
          (openRecommendedPriceModal)="openRecommendedPriceModal()"
          (clicked)="closeModal()"
        />
      }

      <div class="c__modal-errors">
        @if (quantityExceededError) {
          <span [attr.data-color]="'error-base'">
            {{ 'cart.modal.add.quantityExceededError' | translate }}
          </span>
        }
        @if (addedWithQuantityExceededError) {
          <span [attr.data-color]="'error-base'">
            {{ 'cart.modal.add.addedWithQuantityExceededError' | translate }}
          </span>
        }
        @if (addedWithInvalidProductType) {
          <div [attr.data-color]="'error-base'">
            <div>{{ 'cart.modal.add.apology' | translate }}</div>
            <div>{{ 'cart.modal.add.' + invalidProductTypeKey | translate }}</div>
          </div>
        }
        @if (globalError) {
          <span [attr.data-color]="'error-base'">{{ 'cart.modal.add.globalError' | translate }}</span>
        }
      </div>

      @if ( isExtendedWarrantyEnabled &&
            extendedWarrantyData?.length > 0 &&
            !quantityExceededError &&
            !globalError &&
            !addedWithInvalidProductType
      ) {
        <wc-extended-warranty-offers
          [extendedWarrantyData]="extendedWarrantyData"
          [verticalLayout]="false"
          (warrantyClicked)="onClickWarranty($event)"
        />
      }
    </div>
    <footer class="c__modal-actions c__add-to-cart-modal-actions" sd-modal-footer>
      @if (!hideContinueShoppingBtn) {
        <button sd-button (click)="isOpened = false" [isSecondary]="true">
          <span>{{ 'cart.minicart.actions.continue' | translate }}</span>
        </button>
      }
      <button sd-button (click)="goToCart()">{{ 'cart.minicart.actions.cart' | translate }}</button>
    </footer>
  </sd-modal-default>
}

<wc-omnibus-recommended-price-modal [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal" />
